import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function NotFound() {
  const location = useLocation();
  
  useEffect(() => {
    console.log('🔴 NotFound component mounted, redirecting from:', location.pathname);
    // Use replace instead of href to avoid adding to history
    // This ensures the redirect happens immediately
    window.location.replace('/');
  }, [location]);
  
  // Return null since we're redirecting immediately
  return null;
}

export default NotFound;
